import ChevronRightIcon from '@heroicons/react/solid/ChevronRightIcon';
import Link from 'next/link';

import { faqs } from '@/src/constants/FAQs';

import { FAQ } from '../Faqs/FAQ';
import type { IFAQ, IFAQTags } from '../home.interface';

export const SchDistFAQs = ({ tag }: IFAQTags) => {
  return (
    <div className="container mx-auto px-4 pb-16 text-center md:px-16 md:py-20 2xl:px-24">
      <div className="py-8 text-center text-[28px] font-medium text-[#000000] md:text-4xl">
        Frequently Asked Questions
      </div>
      <div className="md:mt-6">
        {faqs.map((faq: IFAQ, index: number) => (
          <FAQ key={index} faq={faq} _tag={tag} />
        ))}
      </div>
      <div>
        <div className="mt-10 flex w-[100%] justify-center">
          <Link
            href="/request-quote"
            className={
              'mr-2 mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] bg-[#318ae5] p-3 text-base font-medium text-white hover:text-white md:py-2'
            }
          >
            Get a quote <ChevronRightIcon className="h-5 w-5" />
          </Link>
          <Link
            href="/schedule-demo"
            className={
              'mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] p-3 text-base font-medium text-[#318AE5] md:py-2'
            }
          >
            Schedule a Demo
          </Link>
        </div>
        <div className="mt-2 flex justify-center">
          or
          <Link
            href="/contact-us"
            className="mx-1 font-semibold text-[#318ae5]"
          >
            Contact us
          </Link>
          for more information.
        </div>
      </div>
    </div>
  );
};
